import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthService } from "@/integrations/api/services/authService";
import App from "./App.tsx";
import "./index.css";

// A tab opened before a deploy still references the old hashed chunk names, which the
// new deploy no longer serves. Reload once to pick up the new index.html; the timestamp
// guard stops a reload loop if a chunk is genuinely missing from the current build.
const CHUNK_RELOAD_KEY = "chunk-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (Date.now() - last < 10_000) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

// SSO handoff from Prosparity 2W: #token=<jwt> must be stored before router/auth mounts
AuthService.consumeSsoTokenFromHash();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
